/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const CursorMenuIconOutline = createIcon({
  displayName: 'CursorMenuIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.5 5.857h3m-3 2.286h1.5"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19.857 11h-5.714l-4.99621e-08-1.77636e-15c-.631261-2.75933e-08-1.143-.511739-1.143-1.143v-5.714l1.42109e-14-1.72588e-07c9.53178e-08-.631261.511739-1.143 1.143-1.143h5.714l4.99621e-08 8.88178e-15c.631261 1.22911e-07 1.143.511739 1.143 1.143v5.714 -1.77636e-15c0 .631261-.511739 1.143-1.143 1.143Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12.833 18.009h-4.175l-2.674 2.651 1.56529e-08-1.55367e-08c-.456261.452874-1.19326.450128-1.64613-.00613249 -.216631-.218251-.338096-.513358-.337867-.820868v-10.657l-3.7739e-08-5.29049e-05c-.000443966-.642859.520337-1.16436 1.1632-1.1648 .309464-.000213719.606274.122813.824842.341894l7.669 7.669 5.73359e-08 5.73512e-08c.45451.454631.454412 1.19163-.000219061 1.64614 -.218493.218435-.514864.341045-.823819.340818Z"
        ></path>
      </g>
    </>
  ),
})

const CursorMenu: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    default:
      return <CustomIcon as={CursorMenuIconOutline} {...props} />
  }
}

export default memo(CursorMenu)
